import {RefObject, useRef} from "react";
import {useParams} from "react-router";
import {css} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {IRankingAnnualParams} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";

import {useGetRegionDetailListBySlugQuery} from "../../../region/api/get_region_detail_list_by_slug";
import {AnnualRankingLinks} from "../AnnualRankingLinks";
import {LocationRankingDescription} from "../LocationRankingDescription";
import {OfferRankingBreadcrumbs} from "../offer_ranking/OfferRankingBreadcrumbs";
import {OfferRankingCreationSteps} from "../offer_ranking/OfferRankingCreationSteps";
import {OfferRankingForm} from "../offer_ranking_form/OfferRankingForm";
import {OfferRankingPanel} from "../OfferRankingPanel";
import {RankingCreationSteps2022} from "./ranking_creation_steps/RankingCreationSteps2022";
import {RankingCreationSteps2023} from "./ranking_creation_steps/RankingCreationSteps2023";
import {ArchiveRankingList} from "./ArchiveRankingList";
import {RankingListBanner} from "./RankingListBanner";

export function ArchiveRanking() {
    const params = useParams<IRankingAnnualParams>();
    const {data: regionResponse} = useGetRegionDetailListBySlugQuery({slug: params.citySlug});

    const region = regionResponse ? regionResponse.results[0] : null;
    const {isMobile} = useUserDevice();
    const creationStepsRef = useRef<HTMLDivElement>(null);

    const handleGetMoreInfoClick = () => {
        if (creationStepsRef.current) {
            creationStepsRef.current.scrollIntoView({behavior: "smooth"});
        }
    };

    return (
        <article>
            <WideContent>
                <OfferRankingBreadcrumbs />
                {!isMobile && <OfferRankingForm horizontal />}
                {isMobile && <OfferRankingPanel />}
                {region && (
                    <>
                        <RankingListBanner handleGetMoreInfoClick={handleGetMoreInfoClick} name_declension_where={region.name_declension_where} />
                        <section className={archiveListSection}>
                            <ArchiveRankingList currentRegion={region} year={params.year} />
                        </section>
                        <RankingCreationStepsForYear year={params.year} scrollRefElem={creationStepsRef} />
                        <LocationRankingDescription currentRegion={region} />
                    </>
                )}
                <AnnualRankingLinks />
            </WideContent>
        </article>
    );
}

function RankingCreationStepsForYear(props: {year: string | undefined; scrollRefElem: RefObject<HTMLDivElement | null>}) {
    switch (props.year) {
        case "2022":
            return <RankingCreationSteps2022 className={creationSteps} scrollRefElem={props.scrollRefElem} />;
        case "2023":
            return <RankingCreationSteps2023 scrollRefElem={props.scrollRefElem} />;
        default:
            return <OfferRankingCreationSteps year={props.year} centerLayout scrollRefElem={props.scrollRefElem} />;
    }
}

const creationSteps = css({
    mb: 9,

    md: {
        mb: 15
    }
});

const archiveListSection = css({
    mb: 3
});
import {RefObject, useRef} from "react";
import {useParams} from "react-router";
import {css} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {IRankingAnnualParams} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";

import {useGetRegionDetailListBySlugQuery} from "../../../region/api/get_region_detail_list_by_slug";
import {AnnualRankingLinks} from "../AnnualRankingLinks";
import {LocationRankingDescription} from "../LocationRankingDescription";
import {OfferRankingBreadcrumbs} from "../offer_ranking/OfferRankingBreadcrumbs";
import {OfferRankingCreationSteps} from "../offer_ranking/OfferRankingCreationSteps";
import {OfferRankingForm} from "../offer_ranking_form/OfferRankingForm";
import {OfferRankingPanel} from "../OfferRankingPanel";
import {RankingCreationSteps2022} from "./ranking_creation_steps/RankingCreationSteps2022";
import {RankingCreationSteps2023} from "./ranking_creation_steps/RankingCreationSteps2023";
import {ArchiveRankingList} from "./ArchiveRankingList";
import {RankingListBanner} from "./RankingListBanner";

export function ArchiveRanking() {
    const params = useParams<IRankingAnnualParams>();
    const {data: regionResponse} = useGetRegionDetailListBySlugQuery({slug: params.citySlug});

    const region = regionResponse ? regionResponse.results[0] : null;
    const {isMobile} = useUserDevice();
    const creationStepsRef = useRef<HTMLDivElement>(null);

    const handleGetMoreInfoClick = () => {
        if (creationStepsRef.current) {
            creationStepsRef.current.scrollIntoView({behavior: "smooth"});
        }
    };

    return (
        <article>
            <WideContent>
                <OfferRankingBreadcrumbs />
                {!isMobile && <OfferRankingForm horizontal />}
                {isMobile && <OfferRankingPanel />}
                {region && (
                    <>
                        <RankingListBanner handleGetMoreInfoClick={handleGetMoreInfoClick} name_declension_where={region.name_declension_where} />
                        <section className={archiveListSection}>
                            <ArchiveRankingList currentRegion={region} year={params.year} />
                        </section>
                        <RankingCreationStepsForYear year={params.year} scrollRefElem={creationStepsRef} />
                        <LocationRankingDescription currentRegion={region} />
                    </>
                )}
                <AnnualRankingLinks />
            </WideContent>
        </article>
    );
}

function RankingCreationStepsForYear(props: {year: string | undefined; scrollRefElem: RefObject<HTMLDivElement | null>}) {
    switch (props.year) {
        case "2022":
            return <RankingCreationSteps2022 className={creationSteps} scrollRefElem={props.scrollRefElem} />;
        case "2023":
            return <RankingCreationSteps2023 scrollRefElem={props.scrollRefElem} />;
        default:
            return <OfferRankingCreationSteps year={props.year} centerLayout scrollRefElem={props.scrollRefElem} />;
    }
}

const creationSteps = css({
    mb: 9,

    md: {
        mb: 15
    }
});

const archiveListSection = css({
    mb: 3
});
